/** The references object of all modules needed for components initialization */
var references = {
    'cart' : require('_core_ext/pages/cart'),
};

module.exports = {
    'references' : references
};
